// extracted by mini-css-extract-plugin
export default {"companyContainer":"fM-z","companyImage":"gM-z","container":"hM-z","heading":"iM-z","darkText":"jM-z","smallHeading":"kM-z","darkBackground":"lM-z","whiteBackground":"mM-z"};